module.exports = __webpack_public_path__ + "static/media/22-9.27ff821d.mp3";